import type { PublicServicePlanPrice } from '@payaca/types/service-plans';

export const getServicePlanMonthlyPrice = (
  prices: PublicServicePlanPrice[]
) => {
  return prices.find(
    (p) => p.billingInterval === 'month' && p.billingIntervalCount === 1
  );
};

export const getServicePlanYearlyPrice = (prices: PublicServicePlanPrice[]) => {
  return prices.find(
    (p) => p.billingInterval === 'year' && p.billingIntervalCount === 1
  );
};
